import React, { useState, useEffect } from 'react'
import id from "./assets/img_authenticate.svg"
import location from "./assets/img_location.svg"
import qr from "./assets/img_qrcode.svg"
import bt from "./assets/img_bt.svg"
import key from "./assets/img_unpairedKey.svg"
import SwipeableViews from 'react-swipeable-views';
import GuideCompContainer from './guideCompContainer'
import { setGoHome } from '../../layout2.0/action/homeAction'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { CMSPath } from '../../config/constant'
import { setDoorKeyGuide } from '../../action/homeAction'

function DoorKeyStepsGuide(props) {

  const [currentPage, setCurrentPage] = useState(0)
  const [totalPage, setTotalPage] = useState(1)

  const {t} =props;

  const [requiredImages, setRequiredImages] = useState({
    keyHelpPremission: "doorKeyGuide_images/img_keyHelpPermission.png",
    keyHelpFD: "doorKeyGuide_images/img_keyHelpFD.png"
  })
  
  const handleChange = (index) => {
    console.log("index", index, currentPage)
    setCurrentPage(index)
  }

  useEffect(() => {
    if((props.frontdeskValidation || props.qrValidation || props.otpValidation) && !localStorage.getItem("VerifiedUser")){
      setTotalPage(2)
      window.scrollTo(0, 0);
    }
  }, [])
  

  return (

  <div className='help-info'>

    <header class="inner-pages w-footer subpages">
      <a onClick={() => { props.setDoorKeyGuide(false); props.setGoHome(true)}} className="button-back"></a>
      <div class="heading align-center">
        <div class="splash-brand">
          <img src={`${CMSPath}${props.logo}`} />
        </div>
      </div>
    </header>

    <section class="widgets padding-0 margin-0 container-bg" style={{minHeight:"100vh"}} >

        <div class="widget-header widget-header-doorkey-howto">
          <div class="widget-header-title">{t("door_key.guide.heading",{defaultValue:"Digital DoorKey Guide"})}</div>
        </div>

        <div class="multi-tips gallery-alt">
          <div class="multi-tips-main">

							<div class="multi-tips-container">
              {props.frontdeskValidation || !props.qrValidation || props.otpValidation ? <SwipeableViews 
              disabled={totalPage == 1}
              index={currentPage}
              onChangeIndex={index => handleChange(index)}>
                <GuideCompContainer 
                  image={requiredImages.keyHelpPremission}
                  heading={`${(props.cameraRequired && !localStorage.getItem("VerifiedUser")) ? props.bluetoothCheckMsg ? "Camera , Location and Bluetooth" : "Camera and Location" : props.bluetoothCheckMsg ? "Location and Bluetooth" : "Location"}`}
                  text= {t("door_key.guide.enable_feature", {defaultValue : "Enable these features on app request"})}
                  subText={`${props.bluetoothCheckMsg ? t("door_key.guide.enable_bluetooth_location",{defaultValue :"*Bluetooth and Location - These are required for digital door key for your room"}) : "*Location - This is required for digital door key for your room"}<br/>${(props.cameraRequired && !localStorage.getItem("VerifiedUser")) ? "*Camera - This is required for authentication for digital door key for your room." : ""}`}
                />
								{(props.frontdeskValidation && props.otpValidation) ? <GuideCompContainer 
                  image={requiredImages.keyHelpFD}
                  heading="Authenticate your identity"
									text="Visit the Front Desk or use your registered phone number/email to verify your identity and get access to your secure door key"
                /> : props.otpValidation ? <GuideCompContainer 
                  image={requiredImages.keyHelpFD}
                  heading="Authenticate your identity"
									text="Use your registered phone number/email to verify your identity and get access to your secure door key"
                /> : props.frontdeskValidation && <GuideCompContainer 
                  image={requiredImages.keyHelpFD}
                  heading="Authenticate your identity"
									text="Visit the Front Desk to verify your identity and get access to your secure door key"
                />}
                </SwipeableViews>
                : <SwipeableViews 
              disabled={totalPage == 1}
              index={currentPage}
              onChangeIndex={index => handleChange(index)}>
                <GuideCompContainer 
                  image={requiredImages.keyHelpPremission}
                  heading={`${(props.cameraRequired && !localStorage.getItem("VerifiedUser")) ? props.bluetoothCheckMsg ? "Camera , Location and Bluetooth" : "Camera and Location" : props.bluetoothCheckMsg ? "Location and Bluetooth" : "Location"}`}
                  text="Enable these features on app request"
                  subText={`${props.bluetoothCheckMsg ? "*Bluetooth and Location - These are required for digital door key for your room" : "*Location - This is required for digital door key for your room"}<br/>${(props.cameraRequired && !localStorage.getItem("VerifiedUser")) ? "*Camera - This is required for authentication for digital door key for your room." : ""}`}
                />
                {<GuideCompContainer 
                  image={qr}
                  heading="Authenticate your identity"
                  text="Scan the Digital Key QR code on the TV of your room to validate your identity and get your digital door key."
                />}
                </SwipeableViews>}
							</div>
						</div>

            <div class="multi-tips-controls">
              {currentPage != totalPage - 1 && <button class="button primary" onClick={() => handleChange(currentPage+1)}>Next</button>}
              <button onClick={props.setStepsGuide} class="button">{(!props.qrValidation || !props.frontdeskValidation || !props.otpValidation) && currentPage == totalPage - 1 ? "Done" :'Skip intro'}</button>
            </div>

            <div class="multi-tips-pages">
							<span class={`pages ${currentPage == 0 && "current"}`}></span>
							{(props.frontdeskValidation || props.qrValidation || props.otpValidation) && !localStorage.getItem("VerifiedUser") && <span class={`pages ${currentPage == 1 && "current"}`}></span>}
						</div>

					</div>
		</section>
    </div>
  )
}

const mapStateToProps = state => {
  return{
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
  }
}

export default connect(mapStateToProps,{setGoHome, setDoorKeyGuide})(withTranslation('translations')(DoorKeyStepsGuide));